import React from 'react'
import { Redirect } from 'react-router-dom'

class BusinessRedirect extends React.PureComponent {
  render() {
    if (this.props.location && this.props.location.search) {
      const search = this.props.location.search.replace('?business=', '')
      return <Redirect to={{ pathname: `/b2busers`, state: {business: search} }} />
    } else {
      return ''
    }
  }
}

export default BusinessRedirect



// WEBPACK FOOTER //
// ./src/js/components/BusinessRedirect.js